import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "c-empty" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "c-empty-title" }
const _hoisted_6 = { class: "name" }
const _hoisted_7 = { class: "desc" }

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: require('@/assets/icons/sidebars/empty.svg'),
          alt: ""
        }, null, 8, _hoisted_4)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('errorEmpty')), 1),
      _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('errorEmptyMessage')), 1)
    ])
  ]))
}